import { toQueryString } from "../../../../service/api_client";
import { fetchGet } from "../../../../ui/pages/content_panel/services/serviceClient";
import { PurchaseVoucherFilter } from "../../models/purchase_model";

export const GetPurchaseVoucherList = async (prop: PurchaseVoucherFilter) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase`;

  const result = await fetchGet(url + toQueryString(prop));
  return result;
};

export const GetPurchaseVouchersRevisedList = async (
  prop: PurchaseVoucherFilter,
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/all-vouchers`;

  const result = await fetchGet(url + toQueryString(prop));
  return result;
};

export const GetPurchaseVoucherExportData = async (
  prop: PurchaseVoucherFilter,
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/export`;

  const result = await fetchGet(url + toQueryString(prop));
  return result;
};

export const GetPurchaseVoucherExportDataByMail = async (
  prop: PurchaseVoucherFilter,
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/csv-export-mail`;

  const result = await fetchGet(url + toQueryString(prop));
  return result;
};

export const GetPurchaseServiceVoucherExportDataByMail = async (
  prop: PurchaseVoucherFilter,
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/srn/csv-export-mail`;

  const result = await fetchGet(url + toQueryString(prop));
  return result;
};

export const GetPurchaseServiceVoucherList = async (
  prop: PurchaseVoucherFilter,
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/srn`;

  const result = await fetchGet(url + toQueryString(prop));
  return result;
};

/** Lets users type "123456" or "po-123456" for an exact PO-123456 match. */
export const normalizePoNumberSearch = (value?: string) => {
  const search = (value ?? "").trim();
  if (!search) return undefined;
  if (/^po-/i.test(search)) return `PO-${search.slice(3)}`;
  if (/^\d{6}$/.test(search)) return `PO-${search}`;
  return search;
};
